import '@styles/pages/seller-page-brand.scss';

import { initCarousel } from '@molecules/carousel';
import { initMap } from '@pages/seller-page-brand/map';
import { initPaginator } from '@pages/seller-page-brand/paginator';
import { initBrandDetails } from './seller-page-brand/brand-details';

initCarousel();
initMap();
initPaginator();
initBrandDetails();
